import type { SVGProps } from "react";
// generated from Filter.svg — do not edit manually
// prettier-ignore
export default function Filter(props: SVGProps<SVGSVGElement>) {
  return (<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" {...props}><path d="M 6 12 H 18 M 3 6 H 21 M 9 18 H 15" stroke="currentColor" strokeWidth="1.5"/></svg>);
}
